import { rem } from 'polished'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import Clickable from 'components/Common/Clickable'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import { sum } from 'lib/array/arrayUtils'
import { pluralizeToString } from 'lib/string/pluralize'

const Container = styled(Clickable)`
  position: relative;
  display: flex;
  height: fit-content;
  align-items: center;
  width: 100%;
  background-color: ${(props) => props.theme.palette.neutral.default.eight};
  border: 1px solid ${(props) => props.theme.palette.neutral.default.five};
  border-radius: ${(props) => props.theme.borderRadius.S};
`

export const Item = styled.div`
  padding: ${rem(8)} ${rem(16)};
  width: 100%;
  justify-self: stretch;

  &:not(:first-child) {
    border-left: 1px solid ${(props) => props.theme.palette.neutral.default.five};
  }
`

interface GuestsProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  title?: string
  occupancies: Array<App.Occupants>
  isFlights?: boolean
}

const DEFAULT_GUESTS_TITLE = 'Guests'

export function GuestsInputTrigger({
  onClick,
  title = DEFAULT_GUESTS_TITLE,
  occupancies,
  isFlights = false,
}: GuestsProps) {
  const guestsInsteadOfAdults = occupancies.some(
    (room) => room.childrenAge?.length,
  )
  const guestCount = useMemo(
    () =>
      sum(
        occupancies,
        (room) =>
          room.adults + (room.childrenAge ? room.childrenAge.length : 0),
      ),
    [occupancies],
  )

  return (
    <Container onClick={onClick}>
      <Item>
        <Caption variant="large" weight="bold">
          {title}
        </Caption>
        <BodyText variant="medium">
          {pluralizeToString(
            guestsInsteadOfAdults ? 'guest' : 'adult',
            guestCount,
          )}{' '}
          {!isFlights && `• ${pluralizeToString('room', occupancies.length)}`}
        </BodyText>
      </Item>
    </Container>
  )
}
